import React from "react";
import { MapPin, Building2, Globe, Monitor } from "lucide-react";
import { Badge } from "./ui/badge";
import { useTranslation } from "react-i18next";

export const CoverageSection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 bg-[#F5F1EA]/50" id="sedes">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 section-reveal">
          <Badge className="bg-white text-[#C8A24D] border-[#E8D5A0] hover:bg-white mb-6 py-1.5 px-4 text-xs font-semibold tracking-wide uppercase">
            {t("coverage.badge")}
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] text-[#0C2340] leading-tight mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
            {t("coverage.title")}
          </h2>
          <p className="text-lg text-[#4A5568] leading-relaxed">
            {t("coverage.subtitle")}
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* Map */}
          <div className="lg:col-span-3 section-reveal">
            <div className="rounded-3xl overflow-hidden border border-[#E8E4DC] shadow-lg shadow-[#0C2340]/5 bg-white">
              <iframe
                title={t("coverage.mapTitle")}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.8130006240217!2d-16.2625721!3d28.4527788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc41cc7c645c7e13%3A0xe988f01b7a248f76!2sC.%20Pepita%20Serrador%2C%202%2C%2038005%20Santa%20Cruz%20de%20Tenerife!5e0!3m2!1ses!2ses!4v1712918000000!5m2!1ses!2ses"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
              />
            </div>
          </div>

          {/* Info Cards */}
          <div className="lg:col-span-2 space-y-4 section-reveal">
            <div className="bg-white rounded-2xl border border-[#E8E4DC] p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#0C2340] flex items-center justify-center shrink-0">
                  <Building2 className="w-5 h-5 text-[#C8A24D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0C2340] mb-1 text-base" style={{ fontFamily: "'DM Serif Display', serif" }}>{t("coverage.card1Title")}</h3>
                  <p className="text-sm text-[#4A5568] leading-relaxed">{t("coverage.card1Desc")}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-[#E8E4DC] p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#0C2340] flex items-center justify-center shrink-0">
                  <Monitor className="w-5 h-5 text-[#C8A24D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0C2340] mb-1 text-base" style={{ fontFamily: "'DM Serif Display', serif" }}>{t("coverage.card2Title")}</h3>
                  <p className="text-sm text-[#4A5568] leading-relaxed">{t("coverage.card2Desc")}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-[#E8E4DC] p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#0C2340] flex items-center justify-center shrink-0">
                  <Globe className="w-5 h-5 text-[#C8A24D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0C2340] mb-1 text-base" style={{ fontFamily: "'DM Serif Display', serif" }}>{t("coverage.card3Title")}</h3>
                  <p className="text-sm text-[#4A5568] leading-relaxed">{t("coverage.card3Desc")}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-[#E8E4DC] p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#0C2340] flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-[#C8A24D]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#0C2340] mb-1 text-base" style={{ fontFamily: "'DM Serif Display', serif" }}>{t("coverage.card4Title")}</h3>
                  <p className="text-sm text-[#4A5568]">
                    Tel: <a href={`tel:${t("footer.phone")}`} className="hover:text-[#C8A24D] transition-colors">{t("footer.phone")}</a>
                  </p>
                  <p className="text-sm text-[#4A5568]">{t("footer.email")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoverageSection;
